/* eslint-disable @typescript-eslint/padding-line-between-statements */
import type { GraphQLErrors, NetworkError } from '@apollo/client/errors';
import type { ServerError } from '@apollo/client';

export function shouldIgnoreNetworkError(error: NetworkError | undefined): boolean {
  try {
    const statusCode = (error as ServerError).statusCode.toString();

    return /^(401|403)$/.test(statusCode);
  } catch {
    return !error;
  }
}

export function shouldIgnoreGraphQLError(errors: GraphQLErrors | undefined): boolean {
  try {
    return !!errors?.find((error) => error.message === 'Unauthorized');
  } catch {
    return !errors;
  }
}
